import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:9000";

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

export const getUsers = async () => {
    const response = await axios.get(`${API_URL}/api/users`, getAuthHeaders());
    return response.data;
};

export const checkUser = async () => {
    const response = await axios.post(`${API_URL}/api/check`, {}, getAuthHeaders());
    return response.data;
};
